import { render, staticRenderFns } from "./innerTab.vue?vue&type=template&id=334e2904&"
import script from "./innerTab.vue?vue&type=script&lang=js&"
export * from "./innerTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports